// extracted by mini-css-extract-plugin
export default {"addresssLayerBox":"AddAddressPopup_addresssLayerBox__7vdT9","addressContainer":"AddAddressPopup_addressContainer__SP-Q6","closeLogin":"AddAddressPopup_closeLogin__QceP8"};